module.exports = __webpack_public_path__ + "img/Pot2.3080d1eb.svg";